import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { questionnaireForOptionsOrganization, QuestionnaireFormikAssign } from "./Constant";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import { useQuestionnaireSortingQuery } from "../../../hooks/ReactQueryHooks/useQuestionnaireSortingQuery";
import { assignedQuestionnaireToOrganization } from "../../api/Questionnaire";
import { getOrganization } from "../../api/Organization";
import { Skeleton, TableCell, Tooltip, Switch } from "@mui/material";
import { debounce } from "lodash";
import MultiSelect from "../../common/textfield/MultiSelect";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";

// edit-program dialog starts
const AssignQuestionnaire = ({ modalData, handleHide, refreshTable }) => {
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);

  const [btnLoading, setBtnLoading] = useState(false);
  const [getCareAptId, setGetCareAptId] = useState();
  const [getCareWaitingId, setGetCareWaitingId] = useState();
  const [getboundCallId, setGetboundCallId] = useState();
  const [getCCItemId, setCCItemId] = useState();
  const [getCareVisitId, setGetCareVisitId] = useState([]);
  const [questionnaireItem, setQuestionnaireItem] = useState([]);
  const [questionnaireItemCC, setQuestionnaireItemCC] = useState([]);

  const [questionnaireApt, setQuestionnaireApt] = useState();
  const [questionnaireWroom, setQuestionnaireWroom] = useState();
  const [questionnaireVvisit, setQuestionnaireVvisit] = useState();
  const [questionnaireCC, setQuestionnaireCC] = useState();

  const [questionnaireInbound, setQuestionnaireInbound] = useState();

  const [initialMultiSelectValue, setInitialMultiSelectValue] = useState([]);
  const [initialCCValues, setInitialCCValues] = useState([]);
  const [selectedVideoVisit, setSelectedVideoVisit] = useState(true);
  const [selectedCC, setSelectedCC] = useState(true);
  const [isClick, setIsClick] = useState(true);
  const [isCCClick, setIsCCClick] = useState(true);

  // ORG SELECTION
  const organizations = useRef([]);
  const [selectedOrgId, setSelectedOrgId] = useState("");

  const fetchOrganizations = async () => {
    try {
      const response = await getOrganization(); // fetch all orgs you can see
      organizations.current = response?.data || [];
    } catch (err) {
      // fallback to adminOrgs if single-org API fails
      organizations.current = adminOrgs || [];
    }
  };
  useEffect(() => { fetchOrganizations(); }, []);
  useEffect(() => {
    if (!selectedOrgId && adminOrgs?.[0]?.id) {
      setSelectedOrgId(adminOrgs[0].id);
    }
  }, [adminOrgs, selectedOrgId]);

  const orgOptions = (organizations.current?.length ? organizations.current : (adminOrgs || []))
    .map(o => ({
      name: o?.name || o?.display || o?.orgName || o?.id,
      value: o?.id
    }));

  let formattedOptions;
  let filteredDataVideoVisit;
  let formattedOptionsForCC;
  let filteredDataCC;

  const { isFetched, data: orgLicensedProducts } = useGetOrgLicensedProducts({});
  const isContactCenterActive = orgLicensedProducts?.callCenter;

  const debouncedGetOrganization = debounce((data, orgId) => {
    if (!orgId) return;
    getOrganization(orgId)
      .then((res) => {
        const assignedQuestionnaire = res?.data?.assignedQuestionnaire || {};

        const foundAptItem = assignedQuestionnaire["getcare-appointment"]
          ? data.find((item) => item?.id === assignedQuestionnaire["getcare-appointment"])
          : "";
        foundAptItem ? setGetCareAptId(foundAptItem.title) : setGetCareAptId("");

        const foundWaitingItem = assignedQuestionnaire["getcare-waitingroom"]
          ? data.find((item) => item?.id === assignedQuestionnaire["getcare-waitingroom"])
          : "";
        foundWaitingItem ? setGetCareWaitingId(foundWaitingItem.title) : setGetCareWaitingId("");

        const foundIcalltem = assignedQuestionnaire["telephone-intake"]
          ? data.find((item) => item?.id === assignedQuestionnaire["telephone-intake"])
          : "";
        foundIcalltem ? setGetboundCallId(foundIcalltem.title) : setGetboundCallId("");

        const videoVisitIds = assignedQuestionnaire["video-visit"] || [];
        setGetCareVisitId(
          videoVisitIds.map((id) => {
            const foundItem = data.find((item) => item?.id === id);
            return foundItem ? foundItem.title : "";
          })
        );

        const CCIds = assignedQuestionnaire["contact-center"] || [];
        setCCItemId(
          CCIds.map((id) => {
            const foundCCItem = data.find((item) => item?.id === id);
            return foundCCItem ? foundCCItem.title : "";
          })
        );

        if (foundAptItem) formik.setFieldValue("questionnaireAptField", foundAptItem?.id || "");
        if (foundWaitingItem) formik.setFieldValue("questionnaireWroomField", foundWaitingItem?.id || "");
        //if (foundIcalltem) formik.setFieldValue("questionnaireInboundCallField", foundIcalltem?.id || "");
      })
      .catch((res) =>
        failed(res?.response?.data?.message || res?.response?.data?.error || res.message)
      );
  }, 500);

  // Fetch questionnaires for SELECTED ORG
  const { isLoading, refetch, isFetching, data: programList } =
    useQuestionnaireSortingQuery({ orgID: selectedOrgId, getAllAuthorized: true, isDefault: true });

  // When program list or org changes, hydrate defaults for that org
  useEffect(() => {
    if (programList && selectedOrgId) {
      debouncedGetOrganization(programList, selectedOrgId);
    }
    return () => debouncedGetOrganization.cancel();
  }, [programList, selectedOrgId]);

  const formik = useFormik({
    ...QuestionnaireFormikAssign,
    onSubmit: (values) => {
      let payload = {};
      let VidoeData = values.questionnaireVvisitField;
      if ((selectedVideoVisit === true && VidoeData.length === 0 && isClick === false) || (VidoeData.length === 0 && isClick === false)) {
        VidoeData = values.questionnaireVvisitField;
      } else {
        (initialMultiSelectValue.length > 0 && VidoeData.length === 0) ? VidoeData = initialMultiSelectValue : VidoeData = values.questionnaireVvisitField;
      }

      let CCData = values.questionnaireContactCenter;
      if ((selectedCC === true && CCData.length === 0 && isCCClick === false) || (CCData.length === 0 && isCCClick === false)) {
        CCData = values.questionnaireVvisitField;
      } else {
        (initialCCValues.length > 0 && CCData.length === 0) ? CCData = initialCCValues : CCData = values.questionnaireVvisitField;
      }

      payload = {
        assignedQuestionnaire: {
          "getcare-appointment": values.questionnaireAptField,
          "getcare-waitingroom": values.questionnaireWroomField,
          "video-visit": VidoeData,
          //"telephone-intake": values.questionnaireInboundCallField,
          "contact-center": values?.questionnaireContactCenter
        }
      };

      setBtnLoading(true);
      assignedQuestionnaireToOrganization(selectedOrgId, payload)
        .then(() => {
          getOrganization(selectedOrgId).then((res) => {
            if (res.data?.assignedQuestionnaire["getcare-appointment"]) {
              const foundAptItem = programList.find(
                (item) => item?.id === res.data?.assignedQuestionnaire["getcare-appointment"]
              );
              foundAptItem ? setGetCareAptId(foundAptItem.title) : setGetCareAptId("");
            }

            if (res.data?.assignedQuestionnaire["getcare-waitingroom"]) {
              const foundWaitingItem = programList.find(
                (item) => item?.id === res.data?.assignedQuestionnaire["getcare-waitingroom"]
              );
              foundWaitingItem ? setGetCareWaitingId(foundWaitingItem.title) : setGetCareWaitingId("");
            }

            if (res.data?.assignedQuestionnaire["telephone-intake"]) {
              const foundIcalltem = programList.find(
                (item) => item?.id === res.data?.assignedQuestionnaire["telephone-intake"]
              );
              foundIcalltem ? setGetboundCallId(foundIcalltem.title) : setGetboundCallId("");
            }

            const videoVisitIds = res.data?.assignedQuestionnaire["video-visit"];
            videoVisitIds
              ? setGetCareVisitId(
                  videoVisitIds.map((id) => {
                    const foundItem = programList.find((item) => item?.id === id);
                    return foundItem ? [foundItem.title] : "";
                  })
                )
              : setGetCareVisitId([]);

            const CCds = res?.data?.assignedQuestionnaire["contact-center"];
            CCds
              ? setCCItemId(
                  CCds?.map((id) => {
                    const foundItem = programList.find((item) => item?.id === id);
                    return foundItem ? [foundItem.title] : "";
                  })
                )
              : setCCItemId([]);

            if (programList) {
              let filteredQuestionnaireVvisitRes = programList
                .filter((item) => item?.purpose === "clinical-visit" && item?.status === "active")
                .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id, id: dataItem?.id }));

              let filteredQuestionnaireCCRes = programList
                .filter((item) => item?.purpose === "contact-center" && item?.status === "active")
                .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id, id: dataItem?.id }));

              if (filteredQuestionnaireVvisitRes.length > 0) {
                setQuestionnaireVvisit(filteredQuestionnaireVvisitRes);
                if (res?.data?.assignedQuestionnaire["video-visit"]?.length > 0) {
                  let itemDataVVisit = res?.data?.assignedQuestionnaire["video-visit"].map((id) => {
                    const foundItem = programList.find((item) => item?.id === id);
                    return foundItem ? foundItem.title : "";
                  });
                  setQuestionnaireItem(filteredQuestionnaireVvisitRes.filter((item) => itemDataVVisit.includes(item.name)));
                  filteredDataVideoVisit = filteredQuestionnaireVvisitRes.filter((item) => itemDataVVisit.includes(item.name));
                }
              }

              if (filteredQuestionnaireCCRes?.length > 0) {
                setQuestionnaireCC(filteredQuestionnaireCCRes);
                if (res?.data?.assignedQuestionnaire["contact-center"]?.length > 0) {
                  let itemDataCC = res?.data?.assignedQuestionnaire["contact-center"].map((id) => {
                    const foundItem = programList.find((item) => item?.id === id);
                    return foundItem ? foundItem.title : "";
                  });
                  setQuestionnaireItemCC(filteredQuestionnaireCCRes.filter((item) => itemDataCC.includes(item.name)));
                  filteredDataCC = filteredQuestionnaireCCRes.filter((item) => itemDataCC.includes(item.name));
                }
              }
            }
          }).catch((res) =>
            failed(res?.response?.data?.message || res?.response?.data?.error || res.message)
          );
          success("Questionnaire Assigned Successfully.");
          handleHide();
          refreshTable();
        })
        .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
        .finally(() => setBtnLoading(false));
    }
  });

  // Build options from programList
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (programList) {
          const filteredQuestionnaireVvisit = programList
            .filter((item) => item?.purpose === "clinical-visit" && item?.status === "active")
            .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id, id: dataItem?.id }));
          if (filteredQuestionnaireVvisit.length > 0) setQuestionnaireVvisit(filteredQuestionnaireVvisit);

          const ccQuestionnaireList = programList
            .filter((item) => item?.purpose === "contact-center" && item?.status === "active")
            .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id, id: dataItem?.id }));
          if (ccQuestionnaireList?.length > 0) setQuestionnaireCC(ccQuestionnaireList);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    return () => {
      debouncedGetOrganization.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programList, formik.values?.questionnaireVvisitField]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (programList) {
          const filteredQuestionnaireApt = programList
            .filter((item) => item?.purpose === "getcare-appointment" && item?.status === "active")
            .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id }));
          setQuestionnaireApt(filteredQuestionnaireApt);

          const filteredQuestionnaireWroom = programList
            .filter((item) => item?.purpose === "getcare-waitingroom" && item?.status === "active")
            .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id }));
          setQuestionnaireWroom(filteredQuestionnaireWroom);

          // const filteredQuestionnaireIcall = programList
          //   .filter((item) => item?.purpose === "telephone-intake" && item?.status === "active")
          //   .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id }));
          // setQuestionnaireInbound(filteredQuestionnaireIcall);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [programList]);

  if (questionnaireVvisit !== undefined) {
    formattedOptions = questionnaireVvisit.map((item) => ({
      name: item.name,
      value: item.value,
      id: item.value
    }));
    filteredDataVideoVisit = questionnaireVvisit.filter((item) => getCareVisitId.includes(item.name));
  } else {
    formattedOptions = [];
  }

  if (questionnaireCC !== undefined) {
    formattedOptionsForCC = questionnaireCC.map((item) => ({
      name: item.name,
      value: item.value,
      id: item.value
    }));
    filteredDataCC = questionnaireCC.filter((item) => getCCItemId?.includes(item.name));
  } else {
    formattedOptionsForCC = [];
  }

  const handlePurposeChange = (fieldName, e) => {
    formik.setFieldValue(fieldName, e.target.value);
    setSelectedVideoVisit(false);
    setSelectedCC(false);
  };

  const handleOrgChange = (e) => {
    const newOrgId = e.target.value;
    setSelectedOrgId(newOrgId);
    formik.setFieldValue("selectedOrgId", newOrgId);

    // reset selections when switching orgs
    formik.setFieldValue("questionnaireAptField", "");
    formik.setFieldValue("questionnaireWroomField", "");
    //formik.setFieldValue("questionnaireInboundCallField", "");
    formik.setFieldValue("questionnaireVvisitField", []);
    formik.setFieldValue("questionnaireContactCenter", []);

    setGetCareAptId("");
    setGetCareWaitingId("");
    setGetboundCallId("");
    setGetCareVisitId([]);
    setCCItemId([]);
    setInitialMultiSelectValue([]);
    setInitialCCValues([]);
  };

  useEffect(() => {
    let initialValue = [];
    let initialValueCC = [];

    if (filteredDataVideoVisit && filteredDataVideoVisit.length > 0) {
      initialValue = filteredDataVideoVisit.map((item) => item.value);
    } else if (questionnaireItem && questionnaireItem.length > 0) {
      initialValue = questionnaireItem.map((item) => item.value);
    }

    if (filteredDataCC && filteredDataCC.length > 0) {
      initialValueCC = filteredDataCC?.map((item) => item.value);
    } else if (questionnaireItemCC && questionnaireItemCC.length > 0) {
      initialValueCC = questionnaireItemCC.map((item) => item.value);
    }

    const newDefaultValue = initialValue.length > -1 ? initialValue : undefined;
    const newDefaultValueCC = initialValueCC?.length > -1 ? initialValueCC : undefined;

    if (JSON.stringify(newDefaultValue) !== JSON.stringify(initialMultiSelectValue)) {
      setInitialMultiSelectValue(newDefaultValue);
    }
    if (JSON.stringify(newDefaultValueCC) !== JSON.stringify(initialCCValues)) {
      setInitialCCValues(newDefaultValueCC);
    }
  }, [filteredDataVideoVisit, questionnaireItem, initialMultiSelectValue, questionnaireItemCC, initialCCValues, filteredDataCC]);

  return (
    <Modal
      show={modalData}
      onHide={handleHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
      backdropClassName
      backdrop={"static"}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">Assign Questionnaire</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
          {/* Organization selector */}
          { orgOptions.length > 1 ? <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
            <Col>Organization</Col>
            <Col>
              <SelectFiled
                keyField={"selectedOrgId"}
                formik={formik}
                placeholder={"Select organization"}
                options={orgOptions}
                onChange={handleOrgChange}
              />
            </Col>
          </Row> : () => {
            setSelectedOrgId(orgOptions[0]?.value); 
            return null 
          }}
          <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
            <Col>
              <h4>Workflow</h4>
            </Col>
            <Col>
              <h4>Questionnaire</h4>
            </Col>
          </Row>
          <hr/>
          <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
            <Col>Get Care - Appointment</Col>
            <Col>
              <SelectFiled
                keyField={"questionnaireAptField"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireApt}
                onChange={(e) => handlePurposeChange("questionnaireAptField", e)}
              />
            </Col>
          </Row>

          <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
            <Col>Get Care - Waiting Room</Col>
            <Col>
              <SelectFiled
                keyField={"questionnaireWroomField"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireWroom}
                onChange={(e) => handlePurposeChange("questionnaireWroomField", e)}
              />
            </Col>
          </Row>

          {/* <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
            <Col>Intake - Inbound Call</Col>
            <Col>
              <SelectFiled
                keyField={"questionnaireInboundCallField"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireInbound}
                onChange={(e) => handlePurposeChange("questionnaireInboundCallField", e)}
              />
            </Col>
          </Row> */}

          <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
            <Col>Clinical Visit</Col>
            <Col>
              <MultiSelect
                required={false}
                keyField={"questionnaireVvisitField"}
                formik={formik}
                options={formattedOptions}
                isSelectAllEnable={true}
                defaultValue={initialMultiSelectValue}
                propsOptionData={0}
                onClick={() => { setIsClick(false); }}
              />
            </Col>
          </Row>

          {/* 
          {isContactCenterActive && (
            <Row style={{ width: "100%", marginBottom: "10px", padding: "5px 10px" }}>
              <Col>Contact Center</Col>
              <Col>
                <MultiSelect
                  required={false}
                  keyField={"questionnaireContactCenter"}
                  formik={formik}
                  options={formattedOptionsForCC}
                  isSelectAllEnable={formattedOptionsForCC?.length > 1}
                  defaultValue={initialCCValues}
                  propsOptionData={0}
                  onClick={() => { setIsCCClick(false); }}
                />
              </Col>
            </Row>
          )}
            */}
          <div className="btn-wrap" style={{ display: "flex", marginTop: "2rem" }}>
            <Button variant="secondary" title="Cancel" onClick={handleHide}>
              Cancel
            </Button>
            <Button type="submit" isLoading={btnLoading}>
              Save
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AssignQuestionnaire;